import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EQueryUsageReportType } from './e-query-usage-report-type';
import { filter, map, switchMap } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../../core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AdminUsageEQueriesReportFilterItemsReadModel } from './model/admin-usage-e-queries-report-filter-items-read-model';
import { KeyValuePair } from '../../../documents/document-filter-item';
import { AdminUsageEQueriesReportFilter } from './model/admin-usage-e-queries-report-filter';
import { AdminUsageEQueriesReport } from './model/admin-usage-e-queries-report';
import * as moment from 'moment';
import { AdminUsageEQueriesReportOptionFilterItemsReadModel, AdminUsageReportOptionFilterItem } from './model/admin-usage-e-queries-report-option-filter-items-read-model';

@Injectable()
export class AdminUsageEQueriesReportFilterItems {
    constructor(private readonly http: HttpClient, private readonly settings: Settings) {
    }

    public getEQueriesReportFilterItems(searchTerm: string, eQueryUsageReportType: EQueryUsageReportType)
        : Observable<KeyValuePair[]> {
        return this.http
            .get(`${this.settings.apiUrl}/admin/e-queries-usage-report-filter-items/${encodeURI(eQueryUsageReportType.toString())}?searchTerm=${searchTerm}`)
            .pipe(map(report => deserialize(report, AdminUsageEQueriesReportFilterItemsReadModel).items));
    }

    public getEQueriesReportOptionFilterItems(keyValue$: Observable<string>, eQueryUsageReportType: EQueryUsageReportType)
        : Observable<AdminUsageReportOptionFilterItem[]> {
        return keyValue$.pipe(
            filter((v) => !!v && !!eQueryUsageReportType),
            switchMap((v) => {
                return this.http
                    .get(`${this.settings.apiUrl}/admin/e-queries-usage-report-option-filter-items/${encodeURI(eQueryUsageReportType.toString())}?value=${v}`)
                    .pipe(map(report => deserialize(report, AdminUsageEQueriesReportOptionFilterItemsReadModel).filterItems));
            }));
    }

    public getUsageEQueriesReport(filterReport: AdminUsageEQueriesReportFilter)
        : Observable<AdminUsageEQueriesReport> {
        return this.http.get(`${this.settings.apiUrl}/admin/e-queries-usage-report/${filterReport.eQueryUsageReportType}`, {params: this.prepareFilterUrlParams(filterReport)})
            .pipe(map(report => deserialize(report, AdminUsageEQueriesReport)));
    }

    public prepareFilterUrlParams(reportFilter: AdminUsageEQueriesReportFilter): HttpParams {
        if (!filter) {
            return null;
        }

        let httpParams = new HttpParams();
        httpParams = httpParams.append('key', reportFilter.key);
        if (reportFilter.filter) {
            reportFilter.filter
                .filter(p => p.value)
                .forEach((filterParam) => {
                    const filterValue = filterParam.value;
                    const paramName = filterParam.def.queryParam;
                    if (paramName === 'date') {
                        httpParams = httpParams.append('dateFrom', (filterValue.dateBegin) ? moment(filterValue.dateBegin).format('YYYY-MM-DDTHH:mm:ss') : '');
                        httpParams = httpParams.append('dateTo', (filterValue.dateEnd) ? moment(filterValue.dateEnd).format('YYYY-MM-DDTHH:mm:ss') : '');
                        return;
                    }

                    if (Array.isArray(filterValue)) {
                        filterValue.filter(v => !!v)
                            .forEach(v => {
                                let paramValue : string = (v.key) ? v.key : v;
                                httpParams = httpParams.append(paramName, encodeURIComponent(paramValue));
                            });
                    } else {
                        let paramValue: string = (filterValue.key) ? filterValue.key : filterValue;
                        httpParams = httpParams.append(paramName, encodeURIComponent(paramValue));
                    }
                });
        }

        return httpParams;
    }
}
